import React, { type SyntheticEvent } from 'react';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { token } from '@atlaskit/tokens';
import { FormattedMessage } from '@atlassian/jira-intl';
import { colors, Flag } from '@atlassian/jira-portfolio-3-common';
import { defaultSorting } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/visualisations';
import messages from './messages';
import type { Props } from './types';

export const getIssueRankWarningFlag = ({ sortByRank }: Props) => {
	const handleSortByRankButtonClick = (_: SyntheticEvent) => {
		sortByRank({
			sorting: defaultSorting,
		});
	};
	const actions = [
		{
			content: <FormattedMessage {...messages.sortByRank} />,
			onClick: handleSortByRankButtonClick,
		},
	];

	return (
		<Flag
			key="issue-rank-warning-flag"
			id="issue-rank-warning-flag"
			title={<FormattedMessage {...messages.title} />}
			description={
				<div>
					<FormattedMessage
						{...messages.sortedPreventIssueRankingDescription}
						values={{
							// @ts-expect-error - Type '(chunks: string) => JSX.Element' is not assignable to type 'ReactNode'.
							strong: (chunks: string) => <strong>{chunks}</strong>,
						}}
					/>
				</div>
			}
			icon={<WarningIcon label="" primaryColor={token('color.icon.warning', colors.Y300)} />}
			actions={actions}
		/>
	);
};
